export const lightTheme = {
  primaryTextColor: '#172b4d',
  primaryColor: '#7289da',
  primaryColorHover: '#5874d8',
  sidebarColor: '#f6f6f6',
  categoryColor: '#ffffff',
  categoySelect: '#ffffff',
  mainBgColor: '#ffffff',
  todoItemColor: '#ffffff',
  lineColor: '#c9c9c9',
  primaryInputColor: '#ffffff',
};
export const darkTheme = {
  primaryTextColor: '#f8fafe',
  primaryColor: '#7289da',
  primaryColorHover: '#5874d8',
  sidebarColor: '#181b1d',
  categoryColor: '#383d41',
  categoySelect: '#292d30',
  mainBgColor: '#202124',
  todoItemColor: '#292d30',
  lineColor: '#464646',
  primaryInputColor: '#303338',
};
